import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@getgrover/ui';
import { Translator } from 'ggApp/modules/translator/components';
import { Container, Button, Gradient, GWrapper } from './styles';

const ReadMore = ({ className, children, refresh, options }) => {
    const containerRef = useRef({});
    const { scrollHeight } = containerRef.current || {};
    const [contentOverflowed, setContentOverflowed] = useState(false);
    const [maxHeight, setMaxHeight] = useState(0);
    const [expanded, setExpanded] = useState(false);

    const checkOverflowState = useCallback(() => {
        if (expanded) return;
        const isOverflowed =
            containerRef?.current.offsetHeight < containerRef?.current.scrollHeight;
        setContentOverflowed(isOverflowed);
    }, [containerRef, expanded]);

    useEffect(() => {
        checkOverflowState();
    }, [checkOverflowState, expanded]);

    useEffect(() => {
        setExpanded(false);
    }, [refresh]);

    const expand = useCallback(() => {
        const { scrollHeight: scrollH } = containerRef.current || {};
        if (getComputedStyle) {
            const styles = getComputedStyle(containerRef.current);

            setMaxHeight(
                (scrollH || 0) +
                    (parseInt(styles.marginTop, 10) || 0) +
                    (parseInt(styles.marginBottom, 10) || 0) +
                    (parseInt(styles.paddingTop, 10) || 0) +
                    (parseInt(styles.paddingBottom, 10) || 0),
            );
        }
        setExpanded(true);
        setContentOverflowed(false);
    }, [containerRef]);

    const hide = useCallback(() => {
        setExpanded(false);
        if (requestAnimationFrame) {
            requestAnimationFrame(() => setContentOverflowed(true));
        }
    }, []);

    return (
        <Container
            className={className}
            ref={containerRef}
            expanded={expanded}
            maxHeight={maxHeight || scrollHeight}
            initialMaxHeight={options?.initialMaxHeight}
        >
            {children}
            {contentOverflowed && (
                <GWrapper>
                    <Gradient />
                    <Button small onClick={expand}>
                        <Translator tk="PDP_DESC_READ_MORE" />
                    </Button>
                </GWrapper>
            )}
            {expanded && options?.showLess && (
                <ButtonV2 small onClick={hide}>
                    <Translator tk="PDP_DESC_READ_LESS" />
                </ButtonV2>
            )}
        </Container>
    );
};

ReadMore.propTypes = {
    className: PropTypes.string,
    refresh: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    options: PropTypes.shape({
        showLess: PropTypes.bool,
        initialMaxHeight: PropTypes.number,
    }),
};

ReadMore.defaultProps = {
    className: '',
    refresh: '',
    showLess: false,
    options: {},
};

export default ReadMore;
